import CaseFolders from "../CaseFolders";
import Notifications from "../Notifications";
import Overview from "../Overview";
import PaymentHistory from "../PaymentHistory";
import AppealAssignedNo from "../AppealAssignedNo";
import Settings from "../Settings";

import ViewCaseFolder from "../case-folder/ViewCaseFolder";
import SearchAssignedCase from "../SearchAssignedCase";
import JoinderRequest from "../JoinderRequest";

export const Registrar2Route = [
  {
    title: "Overview",
    path: "/registrar2/overview",
    component: Overview,
  },
  {
    title: "Case Folders",
    path: "/registrar2/case-folders",
    component: CaseFolders,
  },

  {
    title: "View Case Folder",
    path: "/registrar2/case-folders/view",
    component: ViewCaseFolder,
  },

  {
    title: "Assigned Appeal No",
    path: "/registrar2/assigned-appeal",
    component: AppealAssignedNo,
  },
  {
    title: "Joinder Request",
    path: "/registrar2/joinder-request",
    component: JoinderRequest,
  },
  {
    title: "Search Assigned Cases",
    path: "/registrar2/search-assigned-appeal",
    component: SearchAssignedCase,
  },
  {
    title: "Payment history",
    path: "/registrar2/payment-history",
    component: PaymentHistory,
  },
  {
    title: "Notification",
    path: "/registrar2/notification",
    component: Notifications,
  },
  {
    title: "Setting",
    path: "/registrar2/setting",
    component: Settings,
  },
];
